// What the dashboard sends into a headless Claude session, through the box
// and the wrapper's inbox (docs/features/26-live-chat.md): the same lines the
// Agent SDK writes to the CLI's stdin.

export type Image = { mediaType: string; data: string }

/** A person's message; images go first, as Claude Code's own client sends them. */
export function userMessage(text: string, images: Image[] = []) {
  return {
    type: 'user' as const,
    message: {
      role: 'user' as const,
      content: [
        ...images.map((i) => ({ type: 'image' as const, source: { type: 'base64' as const, media_type: i.mediaType, data: i.data } })),
        { type: 'text' as const, text },
      ],
    },
    parent_tool_use_id: null,
    session_id: '',
  }
}

export function control(requestId: string, request: Record<string, unknown>) {
  return { type: 'control_request' as const, request_id: requestId, request }
}

export const interrupt = (requestId: string) => control(requestId, { subtype: 'interrupt' })
export const setModel = (requestId: string, model: string) => control(requestId, { subtype: 'set_model', model })
export const setPermissionMode = (requestId: string, mode: 'default' | 'acceptEdits' | 'plan' | 'auto' | 'bypassPermissions' | 'dontAsk') =>
  control(requestId, { subtype: 'set_permission_mode', mode })

/**
 * The answer to a `can_use_tool` request. `input` may change what runs (an
 * AskUserQuestion answer travels as `answers` on its input).
 */
export function permissionAnswer(requestId: string, a: { allow: true; input: Record<string, unknown> } | { allow: false; message: string }) {
  return {
    type: 'control_response' as const,
    response: {
      subtype: 'success' as const,
      request_id: requestId,
      response: a.allow ? { behavior: 'allow', updatedInput: a.input } : { behavior: 'deny', message: a.message },
    },
  }
}
